import BaseService from "@/services/BaseService";
import Admin from "@/types/Admin";

export default class AdminService extends BaseService {
    static async addAdmin(organizationId: string, username: string, password: string) {
        return await this.perform<Admin>({
            url: "/portal/admins",
            method: "POST",
            auth: true,
            body: {
                organizationId: organizationId,
                username: username,
                password: password
            }
        });
    }

    static async updateAdmin(organizationId: string, username?: string, password?: string) {
        return await this.perform<Admin>({
            url: "/portal/admins",
            method: "PUT",
            auth: true,
            body: {
                organizationId: organizationId,
                username: username,
                password: password
            }
        });
    }
}